export default (data) => Boolean(data.Input);
